import { useCallback } from "react";

// useFileUpload.ts
export const useFileUpload = (options?: {
  accept?: string;
  onFileSelect?: (file: File) => void;
}) => {
  const selectFile = useCallback(() => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = options?.accept || ".pdf,.doc,.docx,.txt";
    input.onchange = (event) => {
      const file = (event.target as HTMLInputElement).files?.[0];
      if (file) {
        options?.onFileSelect?.(file);
      }
    };
    input.click();
  }, [options]);

  return { selectFile };
};
